<template>
  <v-row align="center" justify="center">
    <v-col class="text-center px-5" cols="12" md="9">
      <v-col cols="12">
        <v-btn
          icon
          title="Consultar por Juez Magistrado y Clase de Proceso"
          aria-label="Consultar por Juez Magistrado y Clase de Proceso"
        >
          <v-icon class="iconos" size="60">fas fa-user-tie</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs
              ? 'font-size: 25px; line-height: 1cm'
              : 'font-size: 32px; line-height: 1cm'
          "
        >
          Consultar por Juez
          <br />Magistrado y Clase de Proceso
        </span>
        <!-- <h3 class="font-weight-regular">Sujeto Procesal</h3> -->
        <v-col cols="12" md="8" class="mx-auto">
          <v-row class="mt-4" v-if="!nombreSelected">
            <v-col cols="9" sm="10">
              <form-input
                label="Busqueda de Jueces por Nombre"
                placeholder="Introduzca el dato.. Ejemplo: Juan Carlos Jimenez"
                v-model="nombre"
                hint="Mínimo cinco (5) caracteres"
                :loading="findBtnPonenteLoading"
                :disabled="findBtnPonenteLoading"
                @submit.prevent="findPonente"
                @keydown.enter="findPonente"
                @keyup.enter="findPonente"
              ></form-input>
            </v-col>
            <v-col cols="3" sm="2">
              <form-button
                :color="!showInputAutocomplete ? 'info' : 'error'"
                class="elevation-1"
                :nameIcon="!showInputAutocomplete ? 'search' : 'broom'"
                :loading="findBtnPonenteLoading"
                :method="!showInputAutocomplete ? findPonente : clearPonente"
                :isFab="true"
                :isIconRight="false"
              ></form-button>
            </v-col>

            <v-col cols="12" class="py-0">
              <!-- :clearable="true" -->
              <v-select
                @change="findClasePonente(nombreSelected)"
                :disabled="!itemNombres[0]"
                :items="itemNombres.map((i) => i.nombre)"
                :required="true"
                v-model="nombreSelected"
                label="Nombre de juez"
                placeholder="Seleccione entre las opciones el magistrado"
                :loading="findBtnPonenteLoading"
              />
            </v-col>
          </v-row>

          <form-input
            v-if="nombreSelected"
            label="Nombre de Magistrado"
            :readonly="true"
            v-model="nombreSelected"
            hint="Mínimo cinco (5) caracteres"
            :disabled="true"
          ></form-input>

          <v-form ref="formClaseProceso" v-model="validForm" lazy-validation>
            <!-- hint="Tres (3) caracteres o más para completar" -->
            <v-select
              v-if="nombreSelected"
              label="Clase de Proceso (ejm. Tutela, Ordinario, Recurso)"
              placeholder="Escriba o Seleccione el dato.. Ejemplo: Jurado"
              :rules="emptyRule"
              :clearable="true"
              v-model="clase"
              :loading="findBtnClasePonenteLoading"
              :items="itemClases.map((i) => i.nombre)"
              :disabled="findBtnClasePonenteLoading"
              clear-icon="fas fa-times"
            />
          </v-form>

          <generate-number
            v-if="nombreSelected"
            v-model="numero"
          ></generate-number>

          <div v-if="nombreSelected">
            <v-btn
              :disabled="!validForm"
              :loading="getStatus.loading"
              color="success"
              :class="`${
                $vuetify.breakpoint.xs ? 'mt-4 ' : ' '
              } mx-2 font-weight-bold`"
              width="200"
              aria-label="Consultar por Juez / Magistrado y Clase de Proceso"
              @click="getjuez"
              >Consultar</v-btn
            >

            <v-btn
              :class="`${
                $vuetify.breakpoint.xs ? 'mt-4 ' : ' '
              } mx-2 font-weight-bold`"
              width="200"
              dark
              color="grey"
              @click="
                clear();
                clearPonente();
              "
              aria-label="Nueva Consulta por Juez / Magistrado y Clase de Proceso"
              >Nueva Consulta</v-btn
            >
          </div>
        </v-col>
      </v-col>
    </v-col>
  </v-row>
</template>
<script>

// Components
import GenerateNumber from "@/components/GenerateNumber";
import FormSelect from "@/components/FormSelect";
import FormInput from "@/components/FormInput";
import FormButton from "@/components/FormButton";
import FormAutocomplete from "@/components/FormAutocomplete";
import { mapGetters } from "vuex";

// Configuration
import axios from '@/config/axios'

export default {
  name: "Home",
  components: {
    GenerateNumber,
    FormSelect,
    FormInput,
    FormButton,
    FormAutocomplete,
  },
  data() {
    return {
      // Validate Payload
      validForm: true,
      emptyRule: [(v) => !!v || "Necesario"],

      show: false,
      consulted: false,
      duplicated: 0,
      results: "",
      message: "",
      alertType: "info",

      nombre: "",
      nombreSelected: "",
      itemNombres: [],
      itemClases: [],
      showInputAutocomplete: false,
      clase: "",
      numero: "",

      //Buttons
      findBtnLoading: false,
      findBtnPonenteLoading: false,
      findBtnClasePonenteLoading: false,

      //Tooltips
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters("process", [
      "getProcesos",
      "getSearch",
      "getDetails",
      "getStatus",
      "getDuplicated",
      "getPaginaActualProcesos",
    ]),
  },
  watch: {
    clase(newSelectedArray, oldSelectedArray) {
      this.clase = newSelectedArray;
    },
    showTooltip(newShow, oldShow) {
      console.log(newShow);
      console.log(oldShow);
    },
    getPaginaActualProcesos(pagina) {
      this.getjuez();
    },
  },
  methods: {
    async find() {
      try {
        this.findBtnLoading = true;

        let data = await axios.get(
          `/Procesos/Consulta/JuezClaseProceso?ponente=${this.nombreSelected}&claseProceso=${this.clase}&codificacionDespacho=${this.numero}`
        );
        this.findBtnLoading = false;
      } catch (error) {
        console.log(error);
        this.findBtnLoading = false;
      }
    },
    async getjuez() {
      if (this.$refs.formClaseProceso.validate()) {
        await this.$store.dispatch("process/juez", {
          ponente: this.nombreSelected,
          claseProceso: this.clase,
          codificacionDespacho: this.numero,
        });

        

        if (!this.getProcesos.length) {
          this.consulted = true;

          if (!this.getStatus.error) {
            this.$store.dispatch(
              "process/mostrarNotificacionRespuestaVacia",
              this.soloActivos
            );
          } else {
            this.$store.dispatch("process/mostrarNotificacionError");
          }
        } else if (this.getProcesos.length > 1) {
          this.consulted = true;
          this.$store.dispatch(
            "process/mostraNotificacionVariosRegistros",
            "Jueces"
          );
        }

        this.duplicated = 0;
      }
    },
    clear() {
      this.nombre = "";
      this.clase = "";
      this.$bus.emit("clear-generate-number");
      this.$store.commit("process/clearProcesos");
    },
    async findPonente() {
      try {
        this.findBtnPonenteLoading = true;

        let data = await axios.get(
          `/Lista/Ponentes/${this.nombre}`
        );
        this.itemNombres = [...this.itemNombres, ...data.data] || [];
        this.showInputAutocomplete = true;
        this.findBtnPonenteLoading = false;
        this.showTooltip = true;
      } catch (error) {
        // console.log(error.response);
        this.$store.dispatch("process/showNotifier", {
          type: "error",
          message: error.response.data.Message,
        });
        this.findBtnPonenteLoading = false;
      }
    },

    clearPonente() {
      this.showInputAutocomplete = false;
      this.itemNombres = [];
      this.nombreSelected = "";
      this.nombre = "";
      this.clase = "";
      this.itemClases = [];
    },

    async findClasePonente(nombre) {
      try {
        this.findBtnClasePonenteLoading = true;

        let data = await axios.get(
          `/Lista/PonenteClasesProceso/${nombre}`
        );
        this.itemClases = data.data;
        this.findBtnClasePonenteLoading = false;
      } catch (error) {
        this.findBtnClasePonenteLoading = false;
      }
    },
  },
};
</script>
